import Cookies from 'cookies';
import { SelectionApp } from '../../../../types/app';

import { isReqFromWlPage } from '../../../server';
import { UTMZ_COOKIE_KEY } from '../../../../constants';

export const readUtmCookie = (ctx: SelectionApp.PageContext) => {
    const cookiesContext = Cookies(ctx.req, ctx.res!);
    const { url: realPath = '' } = ctx.req;
    return isReqFromWlPage(realPath) ? '' : decodeURIComponent(cookiesContext.get(UTMZ_COOKIE_KEY) || '');
};
